export default {
  pageTitle: '职位详情',
  allLocation: '全部地址',
  foldLocation: '收起',
  expand: '展开',
  collapse: '收起',
  searchJobs: '搜索职位',
  msg: {
    openInBrowser: '请在浏览器中打开。',
    downloadMessenger: '请先下载"Messenger"。',
    downloadwhatsapp: '请先下载"WhatsApp"。',
    copyUrl: '请复制以下地址'
  },
  disagree: '不同意',
  andContinue: '并继续',
  agree: '同意',
  iAgree: '我同意',
  viewJobs: '查看职位',
  jobDetailSalary: '薪\u3000\u3000水',
  jobDetailRoleType: '工作性质',
  fullTime: '全职',
  partTime: '兼职',
  intern: '实习',
  jobDetailExperience: '工作经验',
  notSpecified: '不限',
  years: '年',
  jobDetailWorkTime: '工作时间',
  updateTime: '更新时间',
  jobLocation: '工作地点',
  closePreview: '关闭预览',
  changeDevice: '切换设备',
  jobDescription: '工作描述',
  henkel: {
    iAgreeHnkel: '我同意汉高',
    declarationOfConsentPersonalData: '同意声明 - 个人资料',
    declarationOfConsentApplicationStatus: '同意声明 - 申请状态',
    pleaseCheckHenkelTerms: '请同意以上条款再继续。'
  },
  commonTosCheck: {
    iAcknowledgeIHaveReadAndAgreeTo: '我同意',
    iCertifyThatIHaveReadAndAgreeToNestlePolicy: '我确认我已阅读并同意',
    iCertifyThatIHaveReadAndAgreeTo: '我同意',
    pleaseAgreeToTheTermsToContinue: '请同意以上条款再继续。',
    amsReadAndAgree: '我已阅读并同意'
  },
  fordApplyJobTipMsg: '*您只能申请一个福特校招职位，请谨慎选择。此申请请使用英文简历。',
  fordApplyJobTipMsg1: '您只能申请 一个 福特校招职位。请确认此职位是您的第一选择。一旦开始申请，您将不能再申请其他福特校招职位。',
  fordApplyJobTipMsg2: '此职位请使用 英文 简历申请。中文简历申请将不予以浏览。',
  reapply: '重新申请',
  applied: '已申请',
  continueFinishApply: '继续完成申请',
  apply: '申请',
  refer: '推荐',
  welcomeToRecommend: '欢迎推荐',
  referralRewards: '推荐奖励',
  uponSuccessfulReferral: '成功推荐后',
  referralBonusesDesc: '奖励发放将依照候选人录用企业内的具体推荐政策',
  referralBonus: '成功推荐奖励',
  next: '下一步',
  yes: '是',
  no: '否',
  areYouAnEmployee: '你是{company}员工吗?',
  submit: '提交',
  yourReferral: '你的推荐',
  toHR: '',
  or: '或',
  share: '分享',
  toAFriend: '给一个朋友',
  importantNotice: '重要提醒!',
  viewFullJobList: '查看其他职位',
  viewOtherJobs: '查看其他职位',
  shareYourPersonally: '转发这个职位给你的小伙伴，获得人才推荐奖励！',
  shareYourPersonallyParm: '转发这个职位给你的小伙伴，获得最高 {balance} 的推荐奖励！',
  sendTo: '发送到：',
  learnMore: '了解更多',
  shareToWechat: '分享至微信',
  holdToHighlight: '点击长摁以下高亮区域',
  selectCopy: '选择 “复制”',
  openWeChatAndPaste: '打开您的微信,在输入框选择“黏贴”即可',
  clickHereForMoreInformation: '点击此处获取更多信息：',
  referTalentsForRewards: '推荐人才获得奖励',
  forFirstPeopleCountApplications: '前{peopleCount}名推荐面试者',
  accordingToEmployee: '依据公司人才推荐项目政策',
  hereIsAJob: '嗨！我觉得你会对这个工作感兴趣！',
  referforRewards: '推荐有奖!',
  upToRMBParm: '最高可获得 {balance} 的推荐奖励！',
  shareJobPoster: '分享工作海报',
  tapToShare: '点击海报分享：',
  saveVideo: '请您的朋友通过视频中的个人二维码申请职位吧！',
  videoIsGenerating: '视频正在生成中',
  StarbucksInternalJobMsg: '哎呀！您好像还没有注册成为星巴克伙伴。您看到的职位只有内部伙伴才能申请。',
  otherInternalJobMsg: '哎呀！您好像还没有注册成为员工。您看到的职位只有内部员工才能申请。',
  ADPReferralTipMessage: '实际情况以ADP微信推荐奖励政策为准',
  moreInfo: '更多信息：',
  clickHereToApply: '如果您已经是员工，请点击<a href="/logout/?backurl=/referral/employee-register/?company_id={companyId}" target="_blank">这里</a>注册。',
  clickHereToApplyStarbucks: '如果您已经是星巴克伙伴，请点击<a href="/logout/?backurl=/referral/employee-register/?company_id={companyId}" target="_blank">这里</a>注册。',
  jobClosed: '职位已过期',
  jobClosedDescription: '非常感谢您对 <b>{companyName}</b> 的关注。很遗憾该职位的申请已截止。如果您对此公司其它职位有兴趣，请点击<b>“查看公司”</b><br/>',
  viewCompany: '查看公司',
  moreCity: '{city1}，{city2}等',
  moreDistinct: '{distinct1}，{distinct2}等',
  moreAddress: '等',
  loading: '加载中…',
  gotIt: '我知道啦!',
  downloadNow: '点击下方按钮下载',
  longPressToSave: '长按保存或发送分享给朋友吧!',
  sharePoster: '分享',
  btn: {
    referJobForRewards: '推荐有奖！',
    customReferralJobRewards: '推荐获得千元奖金'
  },
  label: {
    step: {
      apply: '候选人申请工作',
      interview: '候选人参加面试',
      onboard: '成功入职',
      probation: '通过试用期'
    },
    referrerReward: {
      points: '推荐人奖励 {reward}积分',
      cash: '推荐人奖励 {reward}元',
      payroll: '推荐人奖励 {reward}元'
    },
    reward: {
      points: '{reward}积分',
      cash: '{reward}元',
      payroll: '{reward}元'
    },
    topReferrer: '前{count}名推荐者',
    finalReward: '奖金可能会根据实际的雇佣结果有所浮动'
  },
  message: {
    copySuccess: '复制成功',
    copyFail: '复制失败，请尝试长按复制'
  },
  rewardsClick: '点击查看详细规则'
}
